import request, { ResponseData } from '@/utils/request'

export async function fetchImgList(): Promise<ResponseData<null>> {
  return request('/api/v1/training/storycase', {
    method: 'get',
  })
}
